export default "__VITE_ASSET__9ouZvJ7C__"